module.exports = __webpack_public_path__ + "img/sw.461102b9.svg";